module.exports = __webpack_public_path__ + "static/ankita-mohapatra-9667ca3026b2fbd3e126b2188fa9f752.jpg";